<template>
  <div class="card-body">
    <div class="float-right">
      <p>{{contractCity}}, {{contractOptions.terminationDate.toLocaleDateString()}}</p>
    </div>
    <br>
    <br>
    <br>
    <div class="float-none">
      <p v-if="employee.name.length == 0">DANE PRZYJMUJĄCEGO ZLECENIE</p>
      <div v-else>
        <p>{{employee.companyName}} </p>
        <p>NIP: {{employee.nip}} </p>
        <p>Adres: {{employee.address}}</p>
        <p>{{employee.postalCode}} {{employee.city}}</p>
      </div>
    </div>
    <br>
    <div class="float-right">
      <p v-if="employer.name.lentgh == 0">DANE ZLECENIODAWCY</p>
      <div v-else>
        <p>{{employer.name}}</p>
        <p>NIP: {{employer.nip}}</p>
        <p>Adres: {{employer.address}}</p>
        <p>{{employer.postalCode}} {{employer.city}}</p>
      </div>
    </div>

    <div class="clearfix"></div>
    <div class="float-none">
      <div class="text-center">
        <h3 class="title text-uppercase">Wypowiedzenie Umowy</h3>
      </div>
      <div class="text-justify">
        <p>Ja niżej podpisany {{employeeFullName}}, działając w imieniu {{employeeCompanyName}} wypowiadam umowę o świadczenie usług{{contractNumber}} zawartą dnia {{contractDate}} pomiędzy {{employeerName}} a {{employeeCompanyName}}. Zgodnie z postanowieniami umowy okres wypowiedzenia wynosi {{terminationTime}}.</p>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div class="float-right">
        <p>Z poważaniem</p>
        <p>........................................................................</p>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div class="float-left">
        <p>Potwierdzam otrzymanie wypowiedzenia</p>
        <p>........................................................................</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContractOfEmployment",
  props: {
    employer: Object,
    employee: Object,
    contractOptions: Object
  },
  computed: {
    contractDate: function() {
      return this.contractOptions.contractDate
        ? this.contractOptions.contractDate.toLocaleDateString()
        : "(data)";
    },
    contractNumber: function () {
      return this.contractOptions.contractNumber.length > 0 
        ? ' (nr umowy: ' + this.contractOptions.contractNumber + ')'
        : null
    },
    contractCity: function() {
      return this.contractOptions.city.length > 0
        ? this.contractOptions.city
        : "Miejscowość";
    },
    employeeFullName: function() {
      return this.employee.name.length > 0
        ? this.employee.name
        : "(imię i nazwisko)";
    },
    employeeCompanyName: function() {
      return this.employee.companyName.length > 0
        ? this.employee.companyName
        : "(nazwa zleceniobiorcy)";
    },
    employeerName: function() {
      return this.employer.name.length > 0
        ? this.employer.name
        : "(nazwa zleceniodawcy)";
    },
    terminationTime: function() {
      var result;
      switch (parseInt(this.contractOptions.terminationTime)) {
        case 2:
          result = '3 miesiące';
          break;
        case 3:
          result = this.contractOptions.customTerminationTime;
          break;
        default:
          result = '1 miesiąc';
      }

      return result;
    }
  }
};
</script>

<style scoped>
  .card-body {
    min-height: 1000px;
  }
</style>


  